import React, { useState } from 'react';
import styled from 'styled-components';
import StarRating from './StarRating';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: white;
  border-radius: 12px;
  padding: 30px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
  text-align: center;
`;

const Title = styled.h2`
  margin-top: 0;
  color: #1d1d1f;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #86868b;
  
  &:hover {
    color: #1d1d1f;
  }
`;

const RatingContainer = styled.div`
  margin: 30px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const RatingLabel = styled.p`
  margin-bottom: 10px;
  color: #86868b;
`;

const RatingValue = styled.p`
  font-size: 1.2rem;
  font-weight: bold;
  margin-top: 10px;
  color: #1d1d1f;
`;

const SubmitButton = styled.button`
  background-color: #0071e3;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-top: 20px;
  
  &:hover {
    background-color: #0077ed;
  }
  
  &:disabled {
    background-color: #86868b;
    cursor: not-allowed;
  }
`;

const StarsDescription = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 15px;
  font-size: 0.85rem;
  color: #86868b;
`;

function RatingModal({ version, onSubmit, onClose }) {
  const [selectedRating, setSelectedRating] = useState(0);

  const handleRate = (rating) => {
    setSelectedRating(rating);
  };

  const handleSubmit = () => {
    if (selectedRating > 0) {
      onSubmit(selectedRating);
    }
  };

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={onClose}>×</CloseButton>
        <Title>Rate iOS {version}</Title>
        
        <RatingContainer>
          <RatingLabel>Select your rating:</RatingLabel>
          <StarRating 
            rating={selectedRating} 
            onRate={handleRate}
            integerOnly={true}
          />
          
          {selectedRating > 0 && (
            <RatingValue>{selectedRating} star{selectedRating !== 1 ? 's' : ''}</RatingValue>
          )}
          
          <StarsDescription>
            <span>Poor</span>
            <span>Excellent</span>
          </StarsDescription>
        </RatingContainer>
        
        <SubmitButton 
          onClick={handleSubmit}
          disabled={selectedRating === 0}
        >
          Submit Rating
        </SubmitButton>
      </ModalContent>
    </ModalOverlay>
  );
}

export default RatingModal; 